/**
 * PortalVehicles - Customer's vehicles list
 */

import { useState, useEffect } from 'react';
import { Car, Loader2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { getApiBase } from '../../lib/apiBase';

const API_BASE = getApiBase();

interface Vehicle {
  id: string;
  registration: string;
  make: string;
  model: string;
  year: number | null;
  color: string | null;
  vin: string | null;
}

export function PortalVehiclesPage() {
  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = localStorage.getItem('customer_session');
    if (!sessionId) return;

    fetch(`${API_BASE}/api/customer-portal/vehicles`, {
      headers: { 'X-Customer-Session': sessionId },
    })
      .then((res) => res.json())
      .then((data) => setVehicles(data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-12">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-bold text-gray-900">Mis Vehículos</h1>

      {vehicles.length === 0 ? (
        <Card>
          <CardContent className="p-8 text-center text-gray-500">
            <Car className="h-10 w-10 mx-auto mb-3 text-gray-300" />
            No tiene vehículos registrados.
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-3">
          {vehicles.map((v) => (
            <Card key={v.id}>
              <CardContent className="p-4">
                <p className="text-lg font-mono font-bold text-gray-900">{v.registration}</p>
                <p className="text-sm text-gray-600">
                  {v.make} {v.model}
                  {v.year && ` (${v.year})`}
                </p>
                {v.color && <p className="text-xs text-gray-400 mt-1">Color: {v.color}</p>}
                {v.vin && <p className="text-xs text-gray-400 font-mono">VIN: {v.vin}</p>}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
